

















































import { EnterBreakNode, InputDocNode, ParagraphNode } from '@getaccept/editor-lib';
import { AvatarSize } from '@getaccept/lib-ui';
import { Editor, EditorContent } from '@tiptap/vue-2';
import type { Ref } from '@vue/composition-api';
import { defineComponent, onMounted, ref } from '@vue/composition-api';
import type { PropType } from 'vue';
import History from '@tiptap/extension-history';
import Text from '@tiptap/extension-text';
import type { CommentParticipantDetails } from '../types/comment-participant-details';

export default defineComponent({
  components: {
    EditorContent,
  },
  props: {
    createAt: {
      type: Number,
      default: 0,
    },
    isGhost: {
      type: Boolean,
      default: false,
    },
    isRead: {
      type: Boolean,
      default: false,
    },
    isReply: {
      type: Boolean,
      default: false,
    },
    isResolvable: {
      type: Boolean,
      default: false,
    },
    participantDetails: {
      type: Object as PropType<CommentParticipantDetails>,
      default: () => ({ name: '', thumbUrl: '' }),
    },
    text: {
      type: String,
      default: '',
    },
  },
  setup: props => {
    const editor: Ref<Editor | null> = ref(null);

    const showMessageOptions = ref(false);

    onMounted(async () => {
      let content;

      // TODO: Delete all comments with plain text in DB, remove this try catch
      try {
        content = JSON.parse(props.text);
      } catch (e) {
        content = props.text;
      }

      editor.value = new Editor({
        content,
        editable: false,
        enablePasteRules: false,
        extensions: [InputDocNode, ParagraphNode, Text, History, EnterBreakNode],
      });
    });

    return {
      AvatarSize,
      editor,
      showMessageOptions,
    };
  },
});
